import React from 'react'
import { Button } from 'semantic-ui-react'
import * as Config from '../../../public/external-links'
import Accordion from '../../common/Accordion'

export const EndOfProbationFooter = ({ expanded, setShow, handleDownload }) => {
  return (
    <Accordion
      heading="Your template letter is now ready"
      expanded={expanded}
      onClick={setShow}
    >
      <p>You can download your letter to your device.</p>
      <p>
        This will create a Word document that you can review and edit before you
        send it to your employee.
      </p>
      <h2>Important information</h2>
      <p>
        You should carefully check the terms in your template End of Probation
        letter. You may wish to seek professional advice to make sure they are
        suitable for your business.
      </p>
      <h2>Save to your device</h2>
      <Button className="ui is-primary button" onClick={handleDownload}>
        Download
      </Button>
      <h2>You might also be interested in:</h2>
      <ul>
        <li>
          <a
            target="_blank"
            href={Config.INTERACTIVE_TEMPLATE_MANAGING_PERFORMANCE}
            rel="noreferrer"
            className="external-link"
          >
            Managing performance online course
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href={Config.INTERACTIVE_TEMPLATE_PERFORMANCE_SYSTEM_CHECKLIST}
            rel="noreferrer"
            className="external-link"
          >
            Setting up a performance system checklist (DOCX 32.7KB)
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href={
              Config.INTERACTIVE_TEMPLATE_PERFORMANCE_REVIEW_DISCUSSION_PLAN
            }
            rel="noreferrer"
            className="external-link"
          >
            Performance review discussion plan (DOCX 35.4KB)
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href={Config.INTERACTIVE_TEMPLATE_MANAGING_EMPLOYEES}
            rel="noreferrer"
            className="external-link"
          >
            Managing employees online course
          </a>
        </li>
      </ul>
    </Accordion>
  )
}
